<template>
  <div>
    <portal to="sidebar-menu">
      <div class="pb-4">
        <nav-back-button to="/ecommerce/invoices">
          {{$t('invoice.menu.backToInvoices')}}
        </nav-back-button>

        <client-card :client="invoice.client" v-if="invoice.client"/>
        <nav-list class="mt-4" :items="navigationItems"/>

      </div>
    </portal>
    <div class="flex w-full">
      <invoice-edit-card class="w-full"
                         :invoice="invoice"
                         @client-change="onClientChange"
                         @refresh="getData"
      >
      </invoice-edit-card>
    </div>
  </div>
</template>
<script>
  import InvoiceService from 'src/services/InvoiceService'
  import InvoiceEditCard from './InvoiceEditCard'
  import ClientCard from 'src/components/Cards/ClientCard'
  import invoiceStatuses from 'src/config/invoiceStatuses'

  export default {
    name: 'invoice-edit',
    components: {
      InvoiceEditCard,
      ClientCard
    },
    data () {
      return {
        invoiceStatuses,
        invoice: {
          status: ''
        },
        loading: false
      }
    },
    computed: {
      navigationItems() {
        return [
          {
            name: this.$t('generic.settings'),
            type: 'group'
          },
          {
            routeName: 'invoice_third_parties',
            name: this.$t('client.management.menu.thirdParties'),
          },
        ]
      }
    },
    methods: {
      onClientChange (client) {
        this.invoice.client = client
      },
      async updateInvoice (status) {
        let oldStatus = this.invoice.status
        this.invoice.status = status
        try {
          this.invoice.lines = this.invoice.invoice_lines.map(l => l.uuid)
          this.invoice.client_uuid = this.invoice.client.uuid
          await InvoiceService.update(this.invoice.uuid, this.invoice)
          this.loading = true
        } catch (e) {
          this.invoice.status = oldStatus
        } finally {
          this.loading = false
        }
      },
      async removeInvoice () {
        await InvoiceService.delete(this.invoice.uuid)
        this.$router.push({name: 'invoice_list'})
      },
      async getData() {
        let { data } = await InvoiceService.getById(id, {
          with: 'client,invoiceLines'
        })
        this.invoice = data
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await InvoiceService.getById(id, {
          with: 'client,invoiceLines'
        })
        if (res.data) {
          next(vm => {
            vm.invoice = res.data
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>
<style>
</style>
